/* =========================================================
   TuchSoft — Articles / Docs archive page helpers.
   The listings are fully server-rendered (rows, chips, pagination);
   search lives in search.js (n8n). This file only does presentation:
     - formats card dates for display;
     - collapses a tag chip bar to ONE row, hiding the overflow behind a
       "Show more (n)" / "Show less" toggle.
   Progressive enhancement: with JS off every chip is simply shown.
   ========================================================= */
(function () {
  'use strict';

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];

  [].forEach.call(document.querySelectorAll('.js-card-date'), function (el) {
    var m = /^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})$/.exec((el.getAttribute('data-date') || '').trim());
    if (m) { el.textContent = (+m[1]) + ' ' + MONTHS[(+m[2]) - 1] + ' ' + m[3]; }
  });

  /* --- one-row chip bar ------------------------------------------------ */
  [].forEach.call(document.querySelectorAll('.articles-tags'), function (bar) {
    var chips = [].slice.call(bar.querySelectorAll('.articles-chip'));
    if (chips.length < 3) { return; }

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'articles-chips-toggle';
    toggle.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    bar.appendChild(toggle);

    var expanded = false;

    function layout() {
      // Start from the full set so the first row can be measured.
      chips.forEach(function (chip) { chip.hidden = false; });
      toggle.hidden = true;

      if (expanded) {
        toggle.textContent = 'Show less';
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        return;
      }

      var firstRowTop = chips[0].offsetTop;
      var hiddenCount = 0;
      chips.forEach(function (chip) {
        if (chip.offsetTop > firstRowTop) { chip.hidden = true; hiddenCount++; }
      });

      if (hiddenCount > 0) {
        toggle.textContent = 'Show more (' + hiddenCount + ')';
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', 'false');
      }
    }

    toggle.addEventListener('click', function () {
      expanded = !expanded;
      layout();
    });

    layout();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { expanded = false; layout(); }, 150);
    });
  });
})();
